import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { extend } from '@thd-nucleus/data-sources';
import './scss/thd-sharebelt.scss';
import { SharebeltContext } from './Sharebelt.context';
import ShareBeltFavorite from './modules/ShareBeltFavorite/ShareBeltFavorite';
import { ProductLoader } from './ProductLoader';

const Sharebelt = ({
  children,
  collectionId,
  horizontal,
  itemId,
  vertical
}) => {

  const shareBeltClasses = classNames('thd-sharebelt', {
    'thd-sharebelt--horizontal': horizontal,
    'thd-sharebelt--vertical': vertical
  });

  const contextValue = {
    collectionId,
    horizontal,
    itemId,
    vertical
  };

  return (
    <div
      className={shareBeltClasses}
      data-section="sharing"
    >
      <SharebeltContext.Provider value={contextValue}>
        {children}
      </SharebeltContext.Provider>
    </div>
  );

};

Sharebelt.displayName = 'Sharebelt';

Sharebelt.propTypes = {
  children: PropTypes.node.isRequired,
  collectionId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  horizontal: PropTypes.bool,
  itemId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  vertical: PropTypes.bool
};

Sharebelt.defaultProps = {
  collectionId: null,
  horizontal: true,
  itemId: null,
  vertical: false
};

Sharebelt.dataModel = extend({}, ProductLoader, ShareBeltFavorite);

export { Sharebelt };
